import type { ProductHighlight } from "@itaas/pep-contracts";
import type { PepLocale } from "../../i18n/types";

interface ProductHighlightGridProps {
  highlights: ProductHighlight[];
  locale: PepLocale;
  title?: string;
}

export function ProductHighlightGrid({ highlights, locale, title }: ProductHighlightGridProps) {
  if (!highlights.length) return null;

  return (
    <section className="mb-5">
      <h2 className="h4 fw-bold mb-4">
        {title ?? (locale === "en" ? "Why choose this platform" : "Pourquoi cette plateforme")}
      </h2>
      <div className="row g-4">
        {highlights.map((block) => {
          const blockTitle =
            locale === "en" && block.titleEn ? block.titleEn : block.titleFr;
          const blockDesc =
            locale === "en" && block.descriptionEn
              ? block.descriptionEn
              : block.descriptionFr;
          return (
            <div className="col-md-6" key={block.titleFr}>
              <div className="pep-product-highlight h-100">
                {block.icon ? (
                  <span className="pep-product-highlight__icon" aria-hidden>
                    {block.icon}
                  </span>
                ) : null}
                <h3 className="h6 fw-bold mb-2">{blockTitle}</h3>
                <p className="text-secondary small mb-0">{blockDesc}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
